<div class="lottie-animation">
  <ng-lottie
    [options]="options()"
    [width]="width()"
    [height]="height()"
  />
</div>